/*
 * @Author: zxl
 * @Date: 2020-03-17 18:17:44
 * @FilePath: \serveradmin_frontend\src\config\env.js
 * @Description:
 */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
// const routerMode = "history";
const routerMode = "history";
let baseImgPath;

let baseUrl = "http://127.0.0.1:8002/";

let accountServe = "";
let commonURL = "http//common.hytap.net/common";
let protocol = window.location.protocol;
if (process.env.NODE_ENV === "development") {
  commonURL = baseUrl;
  baseImgPath = "/img/";
  baseUrl = baseUrl;
} else {
  baseImgPath = "/img/";
  commonURL = baseUrl;
  baseUrl = protocol + baseUrl;
}

export { routerMode, baseImgPath, accountServe, commonURL, baseUrl };